import type { DisplayMode } from '@jira/polaris__domain-field/src/DisplayMode.types.tsx';
import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { createGetFieldByKey } from './createGetFieldByKey.tsx';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateUserFieldDisplayMode =
	(fieldKey: FieldKey, displayMode: DisplayMode, localUpdate = false) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, fieldRemote, createAnalyticsEvent }: Props,
	): Promise<void> => {
		try {
			const field = createGetFieldByKey(fieldKey)(getState());
			if (!field) {
				return undefined;
			}

			const configuration = {
				...field.configuration,
				displayMode,
			};

			if (!localUpdate) {
				await fieldRemote.updateFieldConfiguration({
					oldConfiguration: field.configuration ?? {},
					configuration,
					fieldKey: field.key,
					type: 'updateUserFieldDisplayMode',
				});
			}

			const fields = { ...getState().fields };
			fields[fieldKey] = {
				...fields[fieldKey],
				configuration,
			};
			setState({ fields });

			fireTrackAnalytics(createAnalyticsEvent({}), 'issueFields updated', {
				issueFieldKey: fieldKey,
				issueFieldType: field.type,
				updatedItems: [{ name: 'displayMode' }],
			});
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			onFieldUpdateFailed(err);
		}
	};
